window.addEventListener('load', () => {

    const floors = document.querySelectorAll('.ewiko-projectstructure .floor');
    floors.forEach((element: Element) => {
        const modal = element.querySelector('.modal-wrapper');
        element.addEventListener('click', () => {
            modal.classList.toggle('show');
        });
    });
})